<template>
  <div class="newsDetails">
    <MobileHead />
    <div class="newsContent">
      <div class="nav">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/index' }">{{ $t('navbar.home') }}</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/exhibition' }">{{ $t('navbar.exhibition') }}</el-breadcrumb-item>
          <!-- <el-breadcrumb-item :to="{ name: 'exhibition_det', params: { id: newsForm.hzexhibitorId } }">{{ exName }}</el-breadcrumb-item> -->
          <el-breadcrumb-item
            ><span class="navTitle" style="color:#006FB8; font-weight: 400;">{{ newsForm.newsTitle }}</span></el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>

      <div class="content">
        <div class="title">
          {{ newsForm.newsTitle }}
        </div>

        <div class="row1">
          <div class="date">
            {{ newsForm.createDate }}
          </div>
          <div class="icon" @click="goShare">
            <img src="../../../static/share.png" alt="" />
            <span class="shareTxt">{{ $t('common.share') }}</span>
          </div>
        </div>

        <div class="strip">
          <div class="strip_blue"></div>
        </div>

        <div class="article">
          <div v-html="newsForm.content"></div>
        </div>

        <div class="strip"></div>
      </div>
      <div class="others" v-if="newsForm.frontId || newsForm.backId">
        <div v-if="newsForm.frontId">
          <span style="margin-right: 4vw">{{ $t('exhibition.lastPage') }}</span> <span class="go" @click="goLast">{{ newsForm.frontName }}</span>
        </div>
        <div style="margin-top: 6.6vw" v-if="newsForm.backId">
          <span style="margin-right: 4vw">{{ $t('exhibition.nextPage') }}</span> <span class="go" @click="goNext">{{ newsForm.backName }}</span>
        </div>
      </div>
    </div>
    <Share :shareVisiable="shareVisiable" @closePannel="closePannel" :shareContentTitle="shareContentTitle" :shareContentUrl="shareContentUrl" />
    <Foot />
  </div>
</template>

<script>
import MobileHead from '../../../common/mobile/head.vue';
import Foot from '../../../common/mobile/footBottom.vue';
import { forMat } from '../../../../utils/common';
import { getNewsDetail, getexhibit } from '../../../../api/exhibitor';
import Share from '../../../common/mobile/share.vue';

export default {
  name: '',
  components: { MobileHead, Foot, Share },

  data() {
    return {
      baseUrl: forMat(),
      id: this.$route.query.userId,
      newsForm: {},
      exName: '',
      shareVisiable: false, //弹出分享面板
      shareContentTitle: '',
      shareContentUrl: '',
    };
  },
  created() {
    this.getNews();
  },
  methods: {
    closePannel(data) {
      this.shareVisiable = data;
    },
    copyLink() {},
    goShare() {
      this.shareContentTitle = this.newsForm.newsTitle;
      this.shareContentUrl = window.location.href;
      this.shareVisiable = true;
    },
    async getNews() {
      const data = await getNewsDetail({ id: this.id });
      this.newsForm = data.data.data;
      const params = await getexhibit({ id: this.newsForm.hzexhibitorId });
      this.exName = params.data.data.companyNameC;
    },
    goLast() {
      this.id = this.newsForm.frontId;
      this.getNews();
    },
    goNext() {
      this.id = this.newsForm.backId;
      this.getNews();
    },
  },
};
</script>

<style scoped lang="scss">
.newsDetails {
  margin-top: 13.3vw;
  .newsContent {
    padding-left: 2.6vw;
    padding-right: 2.6vw;
    box-sizing: border-box;
    .nav {
      padding-top: 4vw;
      box-sizing: border-box;
      white-space: nowrap;
      width: 90vw !important;
      overflow: hidden;
      .el-breadcrumb {
        width: 100%;
      }
    }
    .content {
      width: 100%;
      margin-top: 6.6vw;
      .title {
        font-size: 4.8vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
      .row1 {
        height: 10.4vw;
        padding-top: 3.7vw;
        padding-bottom: 3.7vw;
        box-sizing: border-box;
        .date {
          color: #999999;
          font-size: 3.2vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          float: left;
        }
        .icon {
          float: right;
          display: flex;
          img {
            width: 5.2vw;
            height: 4.8vw;
            color: #666666;
          }
          .shareTxt {
            font-size: 3.2vw;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666666;
            margin-left: 1vw;
          }
        }
      }

      .strip {
        width: 100%;
        height: 0.5vw;
        background: #e5f0f8;
        margin-bottom: 5.2vw;
        //position: relative;
        .strip_blue {
          background: #006fb8;
          height: 100%;
          width: 32.67vw;
        }
      }

      .article {
        width: 100%;
        line-height: 150%;
        margin-bottom: 11.3vw;
        p {
          margin: 4.8vw 0;
          font-size: 2.4vw;
          color: #333333;
          text-indent: 2em;
        }

        img {
          width: 92vw;
          height: 51.73vw;
          display: block;
          margin: 1.3vw auto 0;
        }

        .subtitle {
          font-size: 3.2vw;
          margin: 2.4vw 0;
          color: #333333;
        }
      }
    }

    .others {
      width: 100%;
      height: 29.87vw;
      color: #666666;
      font-size: 3.2vw;
      padding-top: 1.3vw;
      padding-bottom: 10.67vw;
      box-sizing: border-box;
      .go:hover {
        cursor: pointer;
        color: #006fb8;
      }
    }
  }
}
</style>
<style scoped>
.el-breadcrumb {
  display: flex;
}

.el-breadcrumb >>> .el-breadcrumb__item {
  float: inherit;
}
.article >>> img {
  width: 92vw !important;
  height: 51.73vw !important;
}
.el-breadcrumb__item >>> .el-breadcrumb__inner {
  color: #333 !important;
  font-family: Microsoft YaHei;
  font-weight: 400;
}
.el-breadcrumb >>> .el-breadcrumb__item:nth-child(3) {
  max-width: 55vw;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
</style>
